import {
  selectPermissionResourceDetail,
  useResource,
} from '@bom-nextgen-keycloak/web/core';
import { FeaturePage } from '@bom-nextgen-keycloak/web/shared/data-access';
import {
  AttributeList,
  FormAttribute,
  FormSpinner,
  ProtectedRouter,
} from '@bom-nextgen-keycloak/web/shared/ui';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useResourceDetail2 } from '../../hooks';
import { PARENT_PATH } from '../../shared';

const Attribute: FC = () => {
  const { id = '' } = useParams();
  const { clientId } = useResource();
  const { data, isLoading, updateMutation } = useResourceDetail2(id);
  const { isEditAttributesTab: canEdit } = useSelector(
    selectPermissionResourceDetail
  );

  const handleUpdate = (attributes: AttributeList) => {
    if (data) {
      updateMutation.mutate({
        clientId,
        payload: {
          ...data,
          attributes: {
            ...attributes,
          },
          _id: data._id || '',
          name: data.name || '',
        },
      });
    } else {
      // TODO: Implement a handler
    }
  };

  return isLoading ? (
    <FormSpinner />
  ) : (
    <FormAttribute
      disabled={!canEdit}
      loading={updateMutation.isLoading}
      onSubmit={handleUpdate}
      parentPath={PARENT_PATH}
      values={data?.attributes || {}}
    />
  );
};

const WrappedResourceAttributePage: FC = () => {
  const { canViewAttributesTab } = useSelector(selectPermissionResourceDetail);

  return (
    <ProtectedRouter
      canView={canViewAttributesTab}
      feature={FeaturePage.RESOURCE}
      isEditPage
      navigatePath={PARENT_PATH}
    >
      <Attribute />
    </ProtectedRouter>
  );
};

export { WrappedResourceAttributePage };
